import { createStyles } from "@mantine/core";

export const getSlideBoxShadow = (selected: boolean) =>
  selected
    ? "0px 8px 80px -8px rgba(0, 0, 0, 0.2), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.03);"
    : "0px 2px 20px -2px rgba(0, 0, 0, 0.1), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.03);";

type Props = { selected: boolean; isMobile: boolean; imagesCount: number };
export const useSlideStyles = createStyles(
  (theme, { selected, isMobile, imagesCount }: Props) => ({
    staticSlide: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      maxWidth: "270px",
      width: "100vw",
      [theme.fn.largerThan("sm")]: {
        maxWidth: "360px",
      },
    },
    mediaItem: {
      flex: "1 1",
      border: "0.5px solid rgba(0, 0, 0, 0.1)",
      boxShadow: getSlideBoxShadow(selected),
    },
    video: {
      display: "block",
      objectFit: "contain",
      width: "100%",
    },
    // dynamic
    imageHolder: {
      position: "relative",
      width: selected ? "100%" : "90%",
      transition: "width 450ms ease-in-out",
      opacity: selected ? 1 : 0.5,
    },
    root: {
      display: "flex",
      justifyContent: imagesCount > 2 ? "flex-start" : "center",
    },
    slide: {
      alignSelf: "center",
    },
    container: {
      gap: isMobile ? 20 : 40,
    },
    viewport: {
      overflow: "visible",
      width: 270,
      [theme.fn.largerThan("sm")]: {
        width: 360,
      },
    },
  })
);
